import React from "react";
import {isEmptyObj, isEmptyString} from "../../common/utils";
import {URLs} from "../../common/constants";
import {translate} from '../../i18n/translate.js';
import styles from "../../css/summary/summaryPickupSite.less";

class SummaryPickupSite extends React.Component {
    onRemoveButtonClick = () => {
        this.props.onRemovePickupSite(false);
    };

    onRemoveWaitListButtonClick = () => {
        this.props.onRemovePickupSite(true);
    };

    onChangePickupSiteClick = () => {
        if(this.props.isChangeAllowed()) {
            this.props.onChangePickupSiteClick();
        }
    };

    onChangePickupSiteClickOnce = () => {
        if(this.props.isChangeAllowed()) {
            this.props.onChangePickupSiteClick(true);
        }
    };

    getEmptySummary = () => {
        const pickupSiteLabel = isEmptyString(this.props.pickupSiteLabel)|| this.props.pickupSiteLabel==='null'
            ?translate("Pick-Up Site"):this.props.pickupSiteLabel;
        return (
            <div className="summary-pickupSite-no-selection">
                <div className="summary-section-title">
                    <div className="summary-title-label pickup-site">{pickupSiteLabel}</div>
                </div>
                <div className="summary-content">
                    {translate("selectPickupSiteSummary").replace("{0}", pickupSiteLabel)}
                </div>
                {this.getWaitListSite()}
            </div>)
    };

    renderDistributionDate = (pickupSite) => {
        if (pickupSite.deliveryHours && pickupSite.deliveryHours.length > 0) {
            return translate(pickupSite.deliveryDays) + ', ' + pickupSite.deliveryHours;
        }
        return translate(pickupSite.deliveryDays);
    };

    getSelectedPickupSite = () => {
        const pickupSiteLabel = isEmptyString(this.props.pickupSiteLabel)|| this.props.pickupSiteLabel==='null'
            ?translate("Pick-Up Site"):this.props.pickupSiteLabel;
        const distributionDate = this.renderDistributionDate(this.props.pickupSite);
        const canChange = this.props.allowChangePickupSite || this.props.allowChangePickupSiteOneDelivery;
        const canOnlyChangePermanent = this.props.allowChangePickupSite && !this.props.allowChangePickupSiteOneDelivery;
        return (<div className="summary-selection">
            <div className="summary-section-title">
                <div className="summary-title-label pickup-site">{pickupSiteLabel + (canChange && !canOnlyChangePermanent ? (' | ' + translate('Change')) : '')}</div>
                {canOnlyChangePermanent ?
                    <button id="btnChangeLocation" type="button" className="button btn btn-primary summary-change-button" onClick={this.onChangePickupSiteClick}>{translate("Change")}</button>
                    : undefined
                }
                {this.props.allowChangePickupSite && !canOnlyChangePermanent ?
                    <button id="btnChangeLocation" type="button" className="button btn btn-primary summary-change-button" onClick={this.onChangePickupSiteClick}>{translate("Permanent")}</button>
                    : undefined
                }
                {this.props.allowChangePickupSiteOneDelivery ?
                    <button id="btnChangeLocation" type="button" className="button btn btn-primary summary-change-button" onClick={this.onChangePickupSiteClickOnce}>{translate("Next Delivery")}</button>
                    : undefined
                }
            </div>
            <div className="summary-selected-pick-up-site-container">
                <div>
                    <label className="summary-selected-pick-up-site-title">
                        {this.props.pickupSite.title}
                    </label>
                    <div className="summary-selected-pick-up-site-day-hour">
                        <span className="summary-selected-pick-up-site-day">{distributionDate}</span>
                    </div>
                </div>
                {!this.props.readOnly && this.props.flowType !== URLs.ACCOUNT?
                    <div className="pick-up-site-close-wrapper">
                        <button className="close-button order-summary-item-remove" onClick={this.onRemoveButtonClick} disabled={!this.props.allowRemove}/>
                    </div>
                    : undefined
                }
            </div>
            {this.getWaitListSite()}
        </div>)
    };

    getWaitListSite = () => {
        if(!isEmptyObj(this.props.waitListSite)) {
            const waitListDistributionDate = translate(this.props.waitListSite.deliveryDays) + ', ' + this.props.waitListSite.deliveryHours;
            return (
                <div className="summary-selected-pick-up-site-container">
                    <div className="summary-waitlist-site">
                        <label className="summary-selected-pick-up-site-title">
                            {this.props.waitListSite.title}
                        </label>
                        <div className="summary-selected-pick-up-site-day-hour">
                            <span className="summary-selected-pick-up-site-day">{waitListDistributionDate}</span>
                        </div>
                    </div>
                    <div className="summary-waitlist-label-wrapper">
                        <label className="summary-waitlist-label">{translate("Waitlist")}</label>
                    </div>
                    {!this.props.readOnly ?
                        <div className="pick-up-site-close-wrapper">
                            <button className="close-button order-summary-item-remove" onClick={this.onRemoveWaitListButtonClick} disabled={!this.props.allowRemove}/>
                        </div>
                        : undefined
                    }
                </div>)
        }
    };

    render() {
        return (
            <div>
                {
                    this.props.pickupSite?
                        this.getSelectedPickupSite()
                        :this.getEmptySummary()
                }
            </div>
        );
    }
}

export default SummaryPickupSite;







// WEBPACK FOOTER //
// ./src/components/summary/SummaryPickupSite.js